import collectionApiClient, { CollectionUnion } from '../../../api/collections';
import useKlydoQuery from '../../../hooks/useKlydoQuery';

const useCollectionQuery = (collectionId: string) => {
  return useKlydoQuery<CollectionUnion>({
    queryKey: ['collection', collectionId],
    queryFn: () => collectionApiClient.getCollection(collectionId),
    enabled: !!collectionId,
  });
};

export default useCollectionQuery;
